import { UnitValue } from '@/helpers/unit-formatter/unit-formatter.types';
import { toNumber } from '@/helpers/unit-formatter/unit-formatter.utils';

import { SUPPORTED_UNITS } from '../unit-formatter.constants';

/**
 * Transforms rate values to per-kilowatt-hour units.
 * Currently a passthrough transformer that normalizes the units label to '/kWh'.
 * Future implementations may support conversions between different energy rate units.
 *
 * @param {UnitValue} unitValue - The rate value to transform
 * @param {any} unitValue.value - The numeric rate value
 * @param {string} [unitValue.units] - The current units of the value
 * @param {string} [newUnits] - Target units (currently unused, always outputs '/kWh')
 * @returns {UnitValue} Transformed value with normalized '/kWh' units
 *   - Returns original value if input value is null/undefined
 *
 * @example
 * transformRatePerKwh({ value: 0.12, units: '$/kWh' })
 * // Returns: { value: 0.12, units: '/kWh' }
 *
 * @example
 * transformRatePerKwh({ value: null, units: '/kWh' })
 * // Returns: { value: null, units: '/kWh' } (original value preserved)
 */
export const transformRatePerKwh = (unitValue: UnitValue, newUnits?: string): UnitValue => {
  const value = toNumber(unitValue.value);
  if (value == null || value == undefined) return unitValue;

  switch (newUnits?.toLowerCase()) {
    default:
      return {
        value,
        units: SUPPORTED_UNITS.PER_KWH,
      };
  }
};
